<template>
  <div>
    <MemberCard
      :class="isMobile ? '' : 'rounded rounded-top rounded-md'"
      :style="isMobile ? '' : 'margin-top: -160px;'"
      @openQrcode="openQrcode"
    >
      <div class="px-3 position-relative" style="z-index: 10">
        <MainNumericalValue v-if="showMainNumericalValue" />
      </div>
    </MemberCard>
    <div class="m-3">
      <MemberProgressBar v-if="showProgressBar" />
      <MGMItem
        :activityId="activityId"
        :mgmTemplateType="mgmTemplateType"
        :mgmTemplateTitle="mgmTemplateTitle"
        :mgmTemplateDesc="mgmTemplateDesc"
      />
      <FunctionMenu
        v-for="menu in menus"
        :key="menu.order"
        :menu="menu"
      ></FunctionMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MemberCard from '@/components/mcf/MemberCard.vue';
import MemberProgressBar from '@/components/mcf/MemberProgressBar.vue';
import MainNumericalValue from '@/components/mcf/MainNumericalValue.vue';
import FunctionMenu from '@/components/mcf/FunctionMenu.vue';
import MGMItem from '@/components/mcf/MGMItem.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    MemberCard,
    MemberProgressBar,
    FunctionMenu,
    MainNumericalValue,
    MGMItem,
  },
  data() {
    return {
      backgroundPic: '',
      showProgressBar: false,
      showMainNumericalValue: false,
      menus: [],
      activityId: '',
      mgmTemplateType: '',
      mgmTemplateTitle: '',
      mgmTemplateDesc: '',
    };
  },
  computed: {
    ...mapState(['isMobile']),
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getMemberCenterMenu').then((menus) => {
      if (!menus) return;
      vm.menus = menus
        .sort((a, b) => a.order - b.order)
        .map((x) => ({
          menuWording: x.menuWording,
          order: x.order,
          function: x.function.sort((a, b) => a.order - b.order),
        }));
    });
    vm.$store
      .dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.backgroundPic = vm.isMobile
          ? setting.backgroundMobilePic
          : setting.backGroundPic;
        vm.showProgressBar = pageSettingGetter.getFunction(
          setting,
          'UserPointsInfo',
        ).isShow;
        vm.showMainNumericalValue = pageSettingGetter.getFunction(
          setting,
          'KeyIndicators',
        ).isShow;
      });

    this.getMGMInfo().then((res) => {
      if (res.success) {
        const data = res.data[0];
        if (data.ismgmTemplate) {
          this.activityId = data.activityId;
          this.mgmTemplateType = data.mgmTemplateType;
          this.mgmTemplateTitle = data.mgmTemplateTitle;
          this.mgmTemplateDesc = data.mgmTemplateDesc;
        }
      }
    });
  },
  methods: {
    ...mapActions(['getMGMInfo']),
    openQrcode() {
      this.$emit('openQrcode');
    },
  },
};
</script>
